<template>
  <div class="region">
    <div class="entry">
      <div class="entry-title">
        <h3>{{info.title}}</h3>
      </div>
      <div class="entry-platform">
        <div
          class="entry-platform-item"
          v-for="(item, index) in entryList"
          :key="index"
          :class="info.language"
        >
          <div class="item-title">
            <div class="item-title-logo">
              <img :src="item.logoImg" alt />
            </div>
            <div class="item-title-operat">
              <p>{{info.itemTitle[index]}}</p>
               <div class="item-summary" :style="{'padding':$route.path.indexOf('en')==1?'10px 11px 10px 11px':'10px 20px 10px 26px'}">
                  <span>{{info.fastPreview}}</span>
              </div>
              <p class="userbtn">
                <a :href="item.loginUrl" target="_blank" style="margin-right:11px;">
                  {{info.login}}
                </a>
                <a :href="item.register" target="_blank">
                  {{info.register}}
                </a>
              </p>
            </div>
          </div>
          <div class="item-serves">
            <a
              class="serve"
              v-for="(el, i) in item.serveNumber"
              :key="i"
              :href="el"
              :class="el!='javascript:;'?'serve-'+(i + 1):'serve-none'"
              :target="el!='javascript:;'?'_blank':''"
            >
              <div class="img"></div>
              <p  :class="el=='javascript:;'?'serveText':''">{{el!='javascript:;'?info.serves[i]:info.serves[i+1]}}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      entryList: [
        {
          logoImg: require("../../assets/images/internetCourt/bjhlwfy_logo_img.png"),
          loginUrl:"https://sspt.bjinternetcourt.gov.cn/cas/login?service=https%3A%2F%2Fsspt.bjinternetcourt.gov.cn%2Fecourt%2Fcaseindex%2Findex%2F",
          register:'http://sspt.bjinternetcourt.gov.cn/ecourt/register/zcxz?only=true',
          serveNumber: ["http://sspt.bjinternetcourt.gov.cn/ecourt/home/ktgg",
            "http://sspt.bjinternetcourt.gov.cn/ecourt/home/wsgk", 
            "http://sspt.bjinternetcourt.gov.cn/ecourt/home/tsgk",
            "https://www.bjinternetcourt.gov.cn/cgi/PreActionfindAllMore.htm?cid=1023",
            "http://sspt.bjinternetcourt.gov.cn/ecourt/home/sfjs", 
            "https://www.bjinternetcourt.gov.cn/cgi/PreActionfindAllMore.htm?cid=1034"]
        },
        {
          logoImg: require("../../assets/images/internetCourt/hzhlwfy_logo_img.png"),
          loginUrl:"http://www.netcourt.gov.cn/portal/main/domain/index.htm",
          register:'https://www.netcourt.gov.cn/register.htm',
          serveNumber: ["https://www.netcourt.gov.cn/portal/main/domain/lassen.htm#lassen/announcement",
            "https://wenshu.court.gov.cn/",
            "http://www.netcourt.gov.cn/portal/main/domain/index.htm",
            "https://www.netcourt.gov.cn/portal/main/domain/lassen.htm#lassen/litigationTools",
            "http://www.netcourt.gov.cn/portal/main/domain/index.htm","javascript:;"]
        },
        {
          logoImg: require("../../assets/images/internetCourt/gzhlwfy_logo_img.png"),
          loginUrl:"https://ols.gzinternetcourt.gov.cn/",
          register:'https://ols.gzinternetcourt.gov.cn/lassen/party/app/register',
          serveNumber: ["https://ols.gzinternetcourt.gov.cn/#lassen/guangzhou/announcement", 
            "https://wenshu.court.gov.cn/", 
            "http://tingshen.court.gov.cn/court/5019", 
            "https://ols.gzinternetcourt.gov.cn/#lassen/guangzhou/litigationTools", 
            "https://ols.gzinternetcourt.gov.cn/","javascript:;"]
        }
      ],
      serveList: "aa"
    };
  },
  props: ["info"]
};
</script>
<style lang="scss" scoped>
.region {
  padding-bottom: 50px;
  // background: url("~img/internetCourt/hlwfyrk_bg_img.png") center / 100% 100%
  //   no-repeat;
      background: #F5F5F5;
  color: #333333;
  .entry {
    width: 1200px;
    margin: 0 auto;
    &-title {
      text-align: center;
      padding: 30px 0;
      font-size: 24px;
      color: #333333;
    }
    &-platform {
      display: flex;
      justify-content: space-between;
      &-item {
        width: 380px;
        // border: 1px solid #e0e1e3;
        background-color: #fff;
        //  box-shadow: 0px 8px 12px 0px rgba(177, 177, 178, 0.58);
        .item {
          &-title {
            display: flex;
            padding: 20px;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &-operat {
              flex: 1;
              padding: 6px 0 0 10px;
              p:first-child {
                height: 13px;
                line-height: 17px;
                font-size: 18px;
                    text-align: center;
              }
              p:nth-child(2) {
                a {
                  i {
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    background: url("~img/internetCourt/login_dl_icon.png")
                      center no-repeat;
                    vertical-align: text-top;
                  }
                  display: inline-block;
                  padding: 0px 10px;
                  border: 1px solid #ccc;
                  font-size: 14px;
                  text-align: center;
                  border-radius: 2px;
                  height: 36px;
                  line-height: 36px;
                  box-sizing: border-box;
                  margin-right: 15px;
                  &:hover {
                    i {
                      background: url("~img/internetCourt/login_dl_hov_pre_icon.png")
                        center no-repeat;
                    }
                    color: #216cff;
                  }
                  &:last-child {
                    &:hover {
                      i {
                        background: url("~img/internetCourt/preview_hov_pre_icon.png")
                          center no-repeat;
                      }
                    }
                    i {
                      background-image: url("~img/internetCourt/login_zc_icon.png");
                    }
                  }
                }
              }
            }
          }
          &-summary {
            padding: 10px 20px 10px 26px;
              span {
                flex: 1;
                line-height: 21px;
                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(120,120,120,1);
              }
          }
         
          &-serves {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            padding-bottom: 20px;
            margin-top: 10px;
            .serve {
              width: 113px;
              height: 113px;
              // box-shadow: 0px 5px 10px 0px rgba(177, 177, 178, 0.58);
              text-align: center;
              color: #333333;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              .img {
                width: 30px;
                height: 30px;
                margin: 0 auto;
                background-repeat: no-repeat;
                background-position: center;
              }
              p {
                margin-top: 10px;
                font-size: 14px;
              }
              &:nth-child(3n - 2) {
                margin-left: 0;
              }
              &:hover {
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 6px 0px rgba(0,0,0,0.15);
                color: #0A57C9;
              }
              &.serve-1 {
                .img {
                  background-image: url("~img/internetCourt/linkItem/announcement_nor_icon.png");
                }
                &:hover {
                  .img {
                    background-image: url("~img/internetCourt/linkItem/announcement_hov_pre_icon.png");
                  }
                }
              }
              &.serve-2 {
                 border-left:1px solid rgba(237,241,251,1);;
                border-right: 1px solid  rgba(237,241,251,1);
                .img {
                  background-image: url("~img/internetCourt/linkItem/Instrument_nor_icon.png");
                }
                &:hover {
                  .img {
                    background-image: url("~img/internetCourt/linkItem/Instrument_hov_pre_icon.png");
                  }
                }
              }
              &.serve-3 {
                .img {
                  background-image: url("~img/internetCourt/linkItem/trial_nor_icon.png");
                }
                &:hover {
                  .img {
                    background-image: url("~img/internetCourt/linkItem/trial_hov_pre_icon.png");
                  }
                }
              }
              &.serve-4 {
                border-top:1px solid  rgba(237,241,251,1);
                .img {
                  background-image: url("~img/internetCourt/linkItem/guide_nor_icon.png");
                }
                &:hover {
                  .img {
                    background-image: url("~img/internetCourt/linkItem/guide_hov_pre_icon.png");
                  }
                }
              }
              &.serve-5 {
                border-left:1px solid rgba(237,241,251,1);;
                border-right: 1px solid  rgba(237,241,251,1);
                border-top:1px solid  rgba(237,241,251,1);
                .img {
                  background-image: url("~img/internetCourt/linkItem/calculation_nor_icon.png");
                }
                &:hover {
                  .img {
                    background-image: url("~img/internetCourt/linkItem/calculation_hov_pre_icon.png");
                  }
                }
              }
              &.serve-6 {
                 border-top:1px solid  rgba(237,241,251,1);
                .img {
                  background-image: url("~img/internetCourt/linkItem/down_nor_icon.png");
                }
                &:hover {
                  .img {
                    background-image: url("~img/internetCourt/linkItem/down_hov_pre_icon.png");
                  }
                }
              }
              &.serve-none{
                 border-top:1px solid  rgba(237,241,251,1);
                 cursor: default;
                .img {
                  background-image: url("~img/internetCourt/linkItem/noclickable_icon.png");
                }
                &:hover{
                   box-shadow:0px 0px 0px 0px #fff;
                }
              }
              .serveText{
                font-size:13px;
                font-family:SourceHanSansCN-Regular,SourceHanSansCN;
                font-weight:400;
                color:rgba(220,220,220,1);
              }
            }
          }
        }
        &.en {
          .item {
            &-title {
              &-operat {
                p:first-child {
                  font-size: 12px;
                }
                p:nth-child(2) {
                  a {
                    width: 100px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
   .userbtn{
            width: 100%;
            height: 32px;
            display: flex;
            justify-content: center;
            a{
              width: 106px;
             border:1px solid #0A57C9;
              height: 32px;;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #0A57C9;
              font-size: 12px;
            }
            a:hover{
              background: #0A57C9;
              color: #fff;
            }
          }
}
</style>
